import { ONBOARDING_SETTABLE_STATUSES, OnboardingStep } from '@today/types'
import { z } from 'zod'

/**
 * `PATCH /t/{slug}/admin/onboarding` (TO-190 REQ-003) — one step, one settable
 * status (`not_started` is never settable), no extras (→ `VALIDATION_ERROR`).
 * The transition and skip rules run in user-service's pure onboarding rules.
 */
export const tenantOnboardingStepPatchSchema = z
	.object({
		step: z.enum(OnboardingStep),
		status: z.enum(ONBOARDING_SETTABLE_STATUSES),
	})
	.strict()

export type TenantOnboardingStepPatchInput = z.infer<typeof tenantOnboardingStepPatchSchema>
